import { ref } from 'vue'
import { ApiService } from '../services/ApiService.js'

export function useCvLoader() {
  const isLoading = ref(false)
  const loadError = ref(null)

  // Load CV data from backend by ID - now using ApiService
  const loadCvById = async (cvId) => {
    if (!cvId) return null

    isLoading.value = true
    loadError.value = null

    try {
      console.log('📡 Loading CV using ApiService:', cvId)
      
      const data = await ApiService.loadCv(cvId)
      console.log('📋 Raw API response data:', data)
      
      if (data.success) {
        // Transform backend data to frontend format
        const transformedData = transformBackendDataToFrontend(data.cv)
        console.log('🔄 Transformed data for frontend:', transformedData)
        return transformedData
      } else {
        throw new Error(data.message || 'Failed to load CV data')
      }
    } catch (error) {
      console.error('❌ Error loading CV:', error)
      loadError.value = error.message
      return null
    } finally {
      isLoading.value = false
    }
  }

  // Transform backend CV data to frontend format
  const transformBackendDataToFrontend = (cvData) => {
    return {
      personalInfo: {
        fullName: cvData.personal_info?.full_name || '',
        email: cvData.personal_info?.email || '',
        phone: cvData.personal_info?.phone || '',
        location: cvData.personal_info?.location || ''
      },
      educationList: cvData.education_entries?.map(edu => ({
        id: edu.id,
        masterEducationEntryId: edu.master_education_entry_id || null,
        institution: edu.institution || '',
        location: edu.location || '',
        startMonth: edu.start_month?.toString() || '',
        startYear: edu.start_year?.toString() || '',
        endMonth: edu.end_month?.toString() || '',
        endYear: edu.end_year?.toString() || '',
        programName: edu.program_name || '',
        programType: edu.program_type || '',
        gpa: edu.gpa || '',
        bulletPoints: edu.bullet_points || [''],
        isCurrent: edu.is_current || false
      })) || [],
      experienceList: cvData.experience_entries?.map(exp => ({
        id: exp.id,
        masterExperienceEntryId: exp.master_experience_entry_id || null,
        jobTitle: exp.job_title || '',
        company: exp.company || '',
        startMonth: exp.start_month?.toString() || '',
        startYear: exp.start_year?.toString() || '',
        endMonth: exp.end_month?.toString() || '',
        endYear: exp.end_year?.toString() || '',
        location: exp.location || '',
        companyDescription: exp.company_description || '',
        bulletPoints: exp.bullet_points || [''],
        isCurrent: exp.is_current || false
      })) || [],
      activitiesList: cvData.activity_entries?.map(act => ({
        id: act.id,
        masterActivityId: act.master_activity_id || null,
        organization: act.organization || '',
        role: act.role || '',
        startMonth: act.start_month?.toString() || '',
        startYear: act.start_year?.toString() || '',
        endMonth: act.end_month?.toString() || '',
        endYear: act.end_year?.toString() || '',
        bulletPoints: act.bullet_points || [''],
        isCurrent: act.is_current || false
      })) || [],
      skillCategories: cvData.skill_category_entries?.map(skill => ({
        name: skill.category_name || '',
        content: skill.content || ''
      })) || []
    }
  }

  return {
    isLoading,
    loadError,
    loadCvById
  }
}